import React from 'react';
import get from 'lodash/get';
import {
  Asterisk,
  Dagger
} from '../../common/notifications/NotificationsTrigger';
import { joinDisclaimers } from './joinDisclaimers';
import { invert } from './utils';
import { withNotifications } from '../../common/notifications/NotificationsContext';
import { SecondaryLine, TotalLine } from './Lines';
import { PriceWithConditionalNotification } from './Price';
import MathBoxGroup from './MathBoxGroup';

const IncentiveLineNotificationDagger = withNotifications(
  ({ line, index, inline, notifications }) => {
    const { disabled, show } = notifications;

    if (inline) {
      return <sup>{index + 1}</sup>;
    }

    if (disabled) {
      return null;
    }

    return (
      <span
        className="disclaimer"
        onClick={event => show(joinDisclaimers(line.disclaimers), event)}>
        {' '}
        <Dagger />
      </span>
    );
  }
);

const IncentivesGroup = ({
  pricing,
  inlineIncentives,
  isSummary,
  isCanada
}) => {
  const {
    incentives,
    employeePrice,
    totalMsrp,
    isSeeDealer,
    luxuryTax: { label: fltLabel, val: fltVal, employeeVal: fltEmployeeVal }
  } = pricing;
  if (isSeeDealer) {
    return null;
  }

  if (!get(incentives, 'lines.length') && !employeePrice) {
    return null;
  }
  const totalCreditsLabel =
    isCanada && incentives.formulaPricing
      ? 'component.pricing.total.credits.formula.pricing'
      : 'component.pricing.total.credits';
  const incentivesLines = incentives.lines.map((line, index) => (
    <SecondaryLine
      key={index}
      label={
        <React.Fragment>
          <span>{line.program}</span>
          <IncentiveLineNotificationDagger
            line={line}
            index={index}
            inline={inlineIncentives}
          />
        </React.Fragment>
      }
      value={invert(line.value)}
    />
  ));

  const fltValue = employeePrice ? fltEmployeeVal : fltVal;
  const LuxuryTaxLine = () => (
    <SecondaryLine label={fltLabel} value={fltValue} />
  );
  const feesLines = [<LuxuryTaxLine key={LuxuryTaxLine} />];

  if (employeePrice) {
    return (
      <MathBoxGroup ruled>
        <TotalLine
          labelKey="total.price"
          price={
            <PriceWithConditionalNotification
              value={totalMsrp}
              notificationName="total-price"
              inlineNotification={!isSummary}
            />
          }
        />
        <TotalLine
          labelKey="total.employee.price"
          price={
            <PriceWithConditionalNotification
              value={employeePrice}
              notificationName="total-employee-price"
              symbol={Asterisk}
              inlineNotification={!isSummary}
            />
          }
          className="math-box__total-employee-price"
        />
        {incentivesLines}
        <TotalLine
          className="math-box__line--total-employee"
          value={invert(incentives.total)}
          labelKey="total.employee.credits"
        />
        {feesLines}
      </MathBoxGroup>
    );
  }

  return (
    <MathBoxGroup ruled>
      {incentivesLines}
      <TotalLine
        value={invert(incentives.total)}
        labelKey={totalCreditsLabel}
      />
    </MathBoxGroup>
  );
};

export default IncentivesGroup;
